/**
 * Resolve o tipo de imóvel do AVALIANDO a partir do tipo cadastrado na inspeção
 * (propertyTypeName), para usar como fallback quando o laudo salvo/automático não
 * traz `dadosImovel.tipoImovel`.
 *
 * Importante: o tipo do Avaliando decide a METODOLOGIA do laudo inteiro
 * (Casa/Terreno → Método Evolutivo; Apartamento → Comparativo Direto) e o
 * comportamento das tabelas do memorial (apartamento não usa CUB, não tem
 * terreno individual etc.). Um fallback fixo em "Apartamento" fazia vistorias
 * de casa/terreno saírem com o memorial errado e valor final zerado.
 */
export function mapPropertyTypeNameToTipoImovel(propertyTypeName?: string | null): string {
  const nome = (propertyTypeName || '').toLowerCase().trim();

  if (/apart|apto|flat|cobertura|kitnet|studio|loft/.test(nome)) {
    return 'Apartamento';
  }

  if (/terreno|lote|ch[áa]cara|fazenda|s[íi]tio|rural|gleba/.test(nome)) {
    return 'Terreno';
  }

  // Qualquer outro nome cadastrado (casa, sobrado, residencial horizontal, comercial...)
  // é tratado como imóvel com terreno → Método Evolutivo.
  if (nome.length > 0) {
    return 'Casa';
  }

  // Sem nenhuma informação de cadastro, mantém o comportamento antigo.
  return 'Apartamento';
}
